// PendingApproval.js - সম্পূর্ণ updated version
import React from 'react';
import { useAdmin } from '../context/AdminContext';
import { useUser } from '../context/UserContext';

const PendingApproval = ({ currentUser }) => {
    const { logout } = useAdmin();
    const { requestAdminRole, loading } = useUser();

    const handleRequestAdminAccess = async () => {
        try {
            console.log('🔄 Requesting admin access...');
            const result = await requestAdminRole();

            if (result.success) {
                alert('✅ Admin request submitted successfully! Please wait for approval.');
                window.location.reload(); // Page refresh করে updated status দেখাবে
            } else {
                alert('❌ ' + result.message);
            }
        } catch (error) {
            console.error('Error requesting admin access:', error);
            alert('❌ Failed to submit admin request: ' + error.message);
        }
    };

    const handleSignOut = () => {
        if (window.confirm('Are you sure you want to sign out?')) {
            logout();
        }
    };

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6">
                        <div className="card shadow-lg border-0 text-center">
                            <div className="card-body p-5">
                                <div className="mb-4">
                                    {currentUser.role === 'pending' ? (
                                        <i className="fas fa-clock fa-4x text-warning mb-3"></i>
                                    ) : (
                                        <i className="fas fa-user-lock fa-4x text-primary mb-3"></i>
                                    )}
                                    <h2 className="card-title fw-bold">
                                        {currentUser.role === 'pending'
                                            ? 'Admin Access Pending'
                                            : 'Admin Access Required'
                                        }
                                    </h2>
                                </div>

                                <div className="card bg-light mb-4 border-0">
                                    <div className="card-body py-3">
                                        <p className="card-text text-muted mb-2">Currently logged in as:</p>
                                        <div className="d-flex align-items-center justify-content-center">
                                            {currentUser.photoURL ? (
                                                <img
                                                    src={currentUser.photoURL}
                                                    alt={currentUser.name}
                                                    className="rounded-circle me-3"
                                                    style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                />
                                            ) : (
                                                <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                                                    style={{ width: '50px', height: '50px', fontSize: '18px', fontWeight: 'bold' }}>
                                                    {currentUser.name?.charAt(0).toUpperCase()}
                                                </div>
                                            )}
                                            <div className="text-start">
                                                <p className="card-text fw-bold text-dark mb-0">{currentUser.name}</p>
                                                <p className="card-text text-muted mb-0 small">{currentUser.email}</p>
                                                <span className={`badge mt-1 ${currentUser.role === 'pending' ? 'bg-warning' : 'bg-info'
                                                    }`}>
                                                    {currentUser.role === 'pending' ? 'Pending Admin Approval' : 'Regular User'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {currentUser.role === 'pending' ? (
                                    <>
                                        <div className="alert alert-warning mb-4">
                                            <i className="fas fa-clock me-2"></i>
                                            <strong>Admin request pending</strong>
                                        </div>
                                        <p className="card-text text-muted mb-4">
                                            Your admin access request has been submitted and is pending approval.
                                        </p>
                                        <p className="card-text text-muted small mb-4">
                                            Please wait for an existing administrator to review and approve your request.
                                            You'll be able to access the admin panel once approved.
                                        </p>
                                        <div className="d-flex justify-content-center gap-2 mb-3">
                                            <button
                                                onClick={() => window.location.reload()}
                                                className="btn btn-outline-primary btn-sm"
                                            >
                                                <i className="fas fa-refresh me-1"></i>
                                                Check Status
                                            </button>
                                            <button
                                                onClick={handleSignOut}
                                                className="btn btn-outline-secondary btn-sm"
                                            >
                                                <i className="fas fa-sign-out-alt me-1"></i>
                                                Sign Out
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="alert alert-info mb-4">
                                            <i className="fas fa-info-circle me-2"></i>
                                            <strong>Admin access required</strong>
                                        </div>
                                        <p className="card-text text-muted mb-4">
                                            You don't have admin privileges for this system yet.
                                        </p>
                                        <p className="card-text text-muted small mb-4">
                                            Click the button below to request admin access. Your request will be
                                            reviewed by an existing administrator.
                                        </p>

                                        <div className="d-flex justify-content-center gap-3 mb-4">
                                            <button
                                                onClick={handleRequestAdminAccess}
                                                className="btn btn-primary btn-lg"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                        Submitting...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-user-shield me-2"></i>
                                                        Request Admin Access
                                                    </>
                                                )}
                                            </button>
                                        </div>

                                        <div className="text-center">
                                            <small className="text-muted">
                                                After submitting your request, please wait for approval.
                                                <br />
                                                You'll be notified once an admin approves your request.
                                            </small>
                                        </div>

                                        <div className="mt-4 pt-3 border-top">
                                            <button
                                                onClick={handleSignOut}
                                                className="btn btn-outline-secondary"
                                            >
                                                <i className="fas fa-sign-out-alt me-2"></i>
                                                Sign Out
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PendingApproval;